import {Injectable} from '@angular/core';
import {CanActivate, CanActivateChild, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {AuthService} from './services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  canActivate() {
    return this.canActivateGuard();
  }

  canActivateChild() {
    return this.canActivateGuard();
  }

  canActivateGuard(): Observable<boolean> {
    return this.authService.isAgentLoggedIn().pipe(
      map((isLoggedIn) => {
        if (!isLoggedIn) {
          this.router.navigate(['/', 'auth']);
          return false;
        } else {
          return true;
        }
      }),
    );
  }
}
